import { Injectable } from '@angular/core';
import { Config } from 'app/shared/services/config';
import { HttpClient, HttpParams } from '@angular/common/http';
import { APIDefectReportEmailRequest, APISendCallEmailRequest, APISurveyEmailRequest, Attachment } from '../models/email';

@Injectable()
export class EmailService {
    constructor(private http: HttpClient) {}

    private createHTTPParams(params: APISurveyEmailRequest | APIDefectReportEmailRequest | APISendCallEmailRequest) {
        let httpParams: HttpParams = new HttpParams();

        // setting all the existing key value of param to HttpParams
        Object.keys(params).forEach(function (key) {
            if (params[key] !== undefined) {
                httpParams = httpParams.append(key, params[key]);
            }
        });

        return httpParams;
    }

    public sendSurveyEmail(params: APISurveyEmailRequest) {
        const httpParams = this.createHTTPParams(params);
        return this.http.post<boolean>(Config.urls.support.survey, null, { params: httpParams });
    }

    public sendDefectReport(params: APIDefectReportEmailRequest, attachment?: Attachment) {
        const httpParams = this.createHTTPParams(params);
        return this.http.post<boolean>(Config.urls.support.defect, attachment, { params: httpParams });
    }

    public sendCallRequest(params: APISendCallEmailRequest) {
        const httpParams = this.createHTTPParams(params);
        return this.http.post<boolean>(Config.urls.support.callRequest, null, { params: httpParams });
    }
}
